import { library } from '@fortawesome/fontawesome-svg-core'

import {
  faArrowLeft,
  faArrowLeftLong,
  faBars,
  faArrowRightToBracket,
  faArrowRightFromBracket,
  faUserTie,
  faHouse,
  faGear,
  faTrashCan,
  faPencil,
  faCancel,
  faSave,
  faClock,
  faArrowRight,
  faInfoCircle,
  faCalendarDays,
  faSortUp,
  faSort,
  faSortDown,
  faX,
  faCaretDown,
  faTimesCircle,
  faPaperclip,
  faCamera,
  faStepForward,
  faStepBackward,
  faArrowUp,
  faArrowDown,
  faChevronLeft,
  faChevronRight,
  faMagnifyingGlass,
  faCreditCard,
  faMailBulk,
  faUsd,
  faCircleInfo,
  faNoteSticky,
  faHashtag,
  faPrint,
  faCopy,
  faCheckCircle,
  faCogs,
  faUsers,
  faMapMarkerAlt,
  faUserLock,
  faClipboardList,
  faRegistered,
  faRocket,
  faCaretLeft,
  faArrowsToCircle,
  faChalkboardUser,
  faCheck,
  faStopwatch,
  faTicketSimple,
  faInbox,
  faMessage,
  faEnvelope,
  faBell,
  faCheckSquare,
  faShoePrints,
  faPlus,
  faLink,
  faFile,
  faListCheck,
  faUserGroup,
  faImage,
  faWarning,
  faWarehouse,
  faGift,
  faEye,
  faDollarSign,
  faReceipt,
  faNotesMedical,
  faBullhorn,
  faChevronDown,
  faChevronUp,
  faDatabase,
  faCircle,
  faCircleDot,
  faBellConcierge,
  faCube,
  faPersonHarassing,
  faDownload,
  faUserCircle,
  faGlasses,
  faPlay,
  faCaretRight,
  faRefresh,
  faPeopleRoof,
  faBug,
  faExclamation,
  faFileContract,
  faLandmarkDome,
  faQuestion,
  faEnvelopesBulk,
  faPiggyBank,
  faUpload,
  faTriangleExclamation,
  faCircleQuestion,
  faMinusSquare,
  faIdBadge,
  faUserGraduate,
  faCircleXmark,
  faComment,
  faPhone,
  faPhoneFlip,
  faMobile,
  faFlaskVial,
  faSitemap,
  faPenToSquare,
  faBook,
  faScrewdriverWrench,
  faLock,
  faLockOpen,
  faFolder,
  faBookmark,
  faBoxesStacked,
  faFileLines,
  faUpDownLeftRight,
  faExternalLink,
  faUser,
  faFolderOpen
} from '@fortawesome/free-solid-svg-icons'

import { faSquare as faSquareRegular } from '@fortawesome/free-regular-svg-icons'

export function getFAIcons() {
  library.add(
    faBars,
    faArrowLeft,
    faArrowRight,
    faArrowLeftLong,
    faBars,
    faArrowRightToBracket,
    faArrowRightFromBracket,
    faUserTie,
    faHouse,
    faGear,
    faTrashCan,
    faPencil,
    faCancel,
    faSave,
    faClock,
    faInfoCircle,
    faCalendarDays,
    faSort,
    faSortUp,
    faSortDown,
    faX,
    faCaretDown,
    faTimesCircle,
    faPaperclip,
    faCamera,
    faArrowUp,
    faArrowDown,
    faStepForward,
    faStepBackward,
    faChevronLeft,
    faChevronRight,
    faMagnifyingGlass,
    faCreditCard,
    faMailBulk,
    faUsd,
    faCircleInfo,
    faNoteSticky,
    faHashtag,
    faPrint,
    faCopy,
    faCheckCircle,
    faCogs,
    faUsers,
    faMapMarkerAlt,
    faUserLock,
    faClipboardList,
    faRegistered,
    faRocket,
    faCaretLeft,
    faArrowsToCircle,
    faChalkboardUser,
    faCheck,
    faStopwatch,
    faTicketSimple,
    faInbox,
    faMessage,
    faEnvelope,
    faSquareRegular,
    faBell,
    faCheckSquare,
    faPlus,
    faLink,
    faFile,
    faPaperclip,
    faListCheck,
    faUserGroup,
    faImage,
    faInbox,
    faWarning,
    faShoePrints,
    faWarehouse,
    faGift,
    faEye,
    faDollarSign,
    faReceipt,
    faNotesMedical,
    faBullhorn,
    faChevronDown,
    faChevronUp,
    faDatabase,
    faCircle,
    faCircleDot,
    faBellConcierge,
    faCube,
    faPersonHarassing,
    faDownload,
    faUserCircle,
    faGlasses,
    faPlay,
    faCaretRight,
    faRefresh,
    faPeopleRoof,
    faBug,
    faExclamation,
    faFileContract,
    faLandmarkDome,
    faQuestion,
    faEnvelopesBulk,
    faPiggyBank,
    faUpload,
    faTriangleExclamation,
    faCircleQuestion,
    faMinusSquare,
    faIdBadge,
    faUserGraduate,
    faCircleXmark,
    faComment,
    faMobile,
    faFlaskVial,
    faSitemap,
    faPenToSquare,
    faBook,
    faWarehouse,
    faScrewdriverWrench,
    faLock,
    faLockOpen,
    faFolder,
    faBookmark,
    faBoxesStacked,
    faFileLines,
    faUpDownLeftRight,
    faExternalLink,
    faUser,
    faFolderOpen
  )
}
